// Imports
import {NotificationProgrammatic as Notification} from 'buefy';

// HTTP Error Handler
export function httpErrorHandler (xhr) {
  let response = xhr.data;

  if (!response) {
    Notification.open({
      type: 'is-danger',
      message: 'An error has occurred'
    });
  }

  if (xhr.status === 422) {
    if (response.error && response.error.message) {
      showNotification(xhr.status, response.error.message);
    }

    if (response.errors) {
      let errorMessage = '';
      let errorCount = 0;

      // eslint-disable-next-line no-unused-vars
      for (const [key, value] of Object.entries(response.errors)) {
        if (errorCount === response.errors.length) {
          errorMessage += value[0];
        } else {
          errorMessage += value[0] + '<br>';
        }

        errorCount++;
      }

      showNotification(xhr.status, errorMessage);
    }

    return false;
  }

  showNotification(xhr.status);
}

export function showNotification (status, message = null) {
  let notificationAttrs = {
    'type': 'is-danger',
    'message': message,
    'duration': 5000,
  };

  switch (status) {
    case 401:
      notificationAttrs.message = 'Unauthorized';
      break;
    case 403:
      notificationAttrs.message = 'You do not have access authority';
      break;
    case 404:
      notificationAttrs.message = 'Not Found';
      break;
    case 500:
      notificationAttrs.message = 'Server Error';
      break;
  }

  Notification.open(notificationAttrs);
}
